// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-popover.colPopover{padding:0!important;min-width:130px;border:1px solid #e1e1e1!important;box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}", ""]);
// Exports
module.exports = exports;
